<div class="" style="width: 100%; display: flex; height: 100vh">
  <!-- Left section - Desktop only -->
  <div class="left-section">
    <div class="left-content">
      <div class="left-text">
        <div class="logo-container">
          <img
            src="/assets/images/logo/MealCheckWhite.webp"
            alt="Logo MealCheck"
            class="logo"
          />
        </div>
        <p class="slogan">Un effectif bien saisi, un service bien servi.</p>
      </div>
    </div>
    <img
      src="/assets/images/representations/two_persons.png"
      alt="Illustration de deux personnes"
      class="left-illustration"
    />
  </div>

  <!-- Right section - Form -->
  <div class="right-section">
    <div class="form-container">
      <!-- Mobile logo -->
      <div class="mobile-logo">
        <img
          src="/assets/images/logo/MealCheckBlack.webp"
          alt="Logo MealCheck"
          class="logo"
        />
      </div>

      <!-- Form header -->
      <div class="form-header">
        <h1>Réinitialisation du mot de passe</h1>
        <div class="info-box">
          <p>
            Entrez votre adresse e-mail et nous vous enverrons un lien pour
            réinitialiser votre mot de passe.
          </p>
        </div>
      </div>

      @if (!emailSent) {
        <div class="form-group">
          <label for="email">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              style="
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
              ></path>
            </svg>
            Adresse e-mail
          </label>
          <div class="input-container">
            <input
              type="email"
              id="email"
              name="email"
              autocomplete="email"
              required
              placeholder="votre@email.com"
              class="text-black w-full !px-4 !py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
              [class.border-red-500]="invalidEmail"
              [class.focus:ring-red-500]="invalidEmail"
              [class.focus:border-red-500]="invalidEmail"
              [formControl]="emailControl"
            />
          </div>
        </div>

        @if (errorMessage) {
          <div class="form-group">
            <div
              class="error-box"
              style="
                background-color: #fee2e2;
                border: 1px solid #fca5a5;
                border-radius: 8px;
                padding: 12px;
                margin-top: 16px;
              "
            >
              <p
                style="
                  color: #dc2626;
                  font-size: 14px;
                  margin: 0;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                "
              >
                <span class="material-icons" style="font-size: 18px"
                  >error_outline</span
                >
                <span>{{ errorMessage | translate }}</span>
              </p>
            </div>
          </div>
        }

        <div class="form-group">
          <button
            type="button"
            (click)="resetPassword()"
            [disabled]="isButtonDisabled"
            class="w-full flex justify-center items-center gap-3 !py-3 !px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:bg-vert-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            [class.bg-emerald-700]="working"
            aria-label="Envoyer le lien de réinitialisation"
          >
            <span
              class="material-icons transition-transform duration-500"
              [class.animate-spin]="rotating"
              [innerHTML]="statusIcon"
            ></span>
            <span [innerHTML]="statusLabel"></span>
          </button>
        </div>
      } @else {
        <div class="form-group" style="text-align: center; padding: 2rem 0">
          <div style="color: #10b981; font-size: 3rem; margin-bottom: 1rem">
            <span class="material-icons" style="font-size: inherit"
              >check_circle</span
            >
          </div>
          <p style="color: #10b981; font-weight: 500; margin-bottom: 1rem">
            E-mail envoyé avec succès !
          </p>
          <p style="color: #6b7280; margin-bottom: 2rem">
            Vérifiez votre boîte de réception et suivez les instructions pour
            réinitialiser votre mot de passe.
          </p>
        </div>
      }

      <div class="form-links">
        <a class="reset-password" routerLink="/login">Retour à la connexion</a>
      </div>
    </div>
  </div>
</div>
